import { Section } from '@app/models';

export const TabDetailsSections: Section[] = [
  { title: 'Event Details', id: 'event-details' },
  { title: 'Activity', id: 'activity' },
  { title: 'Interventions', id: 'interventions' },
  { title: 'Notes', id: 'notes-events' },
];
